import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useCurrentUser } from './useCurrentUser';

export const useCurrentOrganization = ({ onOrganizationChange, immediate = true } = {}) => {
  const $store = useStore();
  const { currentUser } = useCurrentUser();

  const organization = computed(() => {
    const organization = $store.getters.currentOrganization;

    if (!organization) {
      return null;
    }
    return organization;
  });

  const getTeam = (id = 'default') => organization.value.teams.find((t) => t.id === id);

  const getTeamByUid = (uid = currentUser.value.uid) => {
    const team = organization.value.teams.find((t) => t.members.find((m) => m.uid === uid));
    if (team) {
      return team;
    } else if ($store.state.userProfile.type === 'super-user') {
      return organization.value.teams[0];
    }
  };

  if (onOrganizationChange) {
    const handler = async () => {
      if (!organization.value) {
        return;
      }
      await onOrganizationChange(organization.value, { getTeam, getTeamByUid });
    };

    watch(organization, handler, { immediate });
  }

  const getUserDetails = (uid = currentUser.value.uid) => {
    return organization.value.roles.find(({ uid: roleUid }) => roleUid === uid)._uidObj;
  };

  const getTeamRole = (uid = currentUser.value.uid) => {
    return getTeamByUid(uid).members.find(({ uid: roleUid }) => roleUid === uid);
  };

  return {
    organization,
    getUserDetails,
    getTeamByUid,
    getTeam,
    getTeamRole,
    currentUser,
    isAdmin: (uid = currentUser.value.uid) =>
      $store.getters.getRole(uid) === 'admin' || $store.state.userProfile.type === 'super-user',
  };
};
